<h4 class="fd-subtitle">Contato Técnico:</h4>
<form *ngIf="formGroup" [formGroup]="formGroup">
  <div fxLayout="column" fxLayoutAlign="center stretch">
    <div>
      <fd-input [parentForm]="formGroup" [field]="fields.name"> </fd-input>
    </div>
    <div>
      <fd-input (blur)="emailChange($event)" [parentForm]="formGroup" [field]="fields.email"> </fd-input>
    </div>
    <div fxLayoutGap="20px">
      <div fxFlex="50">
        <fd-input [parentForm]="formGroup" [field]="fields.primaryPhone"> </fd-input>
      </div>
      <div fxFlex="50">
        <fd-input [parentForm]="formGroup" [field]="fields.secondaryPhone"> </fd-input>
      </div>
    </div>
    <div>
      <fd-input [parentForm]="formGroup" [field]="fields.mobileNumber"> </fd-input>
    </div>

    <fd-button fdSecondary [content]="'cancelar'" (trigger)="back()"> </fd-button>
    <fd-button [content]="'avançar'" (trigger)="checkEmail()"> </fd-button>
  </div>
</form>
